import * as React from 'react';

function SvgTwitterIcon(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="#DF4046"
      d="M18.326 1.904H21.7l-7.37 8.423L23 21.79h-6.789l-5.317-6.952L4.81 21.79H1.434l7.883-9.01L1 1.904h6.961l4.806 6.354zM17.142 19.77h1.87L6.945 3.817H4.94z"
    />
  </svg>)
}
export default SvgTwitterIcon;
